import { api } from '../utils/apiClient';

export type FrontendEventType =
  | 'selection_result_viewed'
  | 'ci_integration_started'
  | 'upgrade_page_viewed'
  | 'upgrade_completed'
  | 'onboarding_started'
  | 'onboarding_completed'
  | 'cli_install_instructions_viewed'
  | 'cli_downloaded'
  | 'repository_connected'
  | 'ci_config_generated'
  | 'ci_config_copied';

export const trackFrontendEvent = async (
  eventType: FrontendEventType,
  metadata: Record<string, unknown> = {}
) => api.post('/funnel/event', {
  eventType,
  eventSource: 'web',
  metadata,
}).catch(() => undefined);
